export default function Rust_HashMap() {
  return (
    <div>
      <h1>Rust_HashMap Component</h1>
      <p>This is the Rust_HashMap page.</p>
    </div>
  );
}
